import { MainLayout } from '@components/layouts/main.layout';
import { HelmetWrapper } from '@components/shared/helmet.component';
import { PageviewTracker } from '@components/shared/pageview-tracker.component';
import { Tile } from '@components/shared/tile.component';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@components/ui/table';
import { useParentOrganizationProjectsQuery } from '@queries/parent-organizations.query';
import { useGetCurrentUser } from '@queries/users.query';
import { routes } from '@routes';
import { Navigate } from 'react-router-dom';

const formatLocation = (params: { city?: string; state?: string }): string => {
  const { city, state } = params;
  const parts = [city, state].filter(Boolean);
  return parts.length > 0 ? parts.join(', ') : '—';
};

const formatCountry = (country?: string): string => {
  return country || '—';
};

export const ParentProjectsPage: React.FC = () => {
  const { isPending: isUserPending, isInnovator, isSelectedCompanyParentOrganization } = useGetCurrentUser();
  const { data: projectsData, isPending: isProjectsPending } = useParentOrganizationProjectsQuery();

  const projects = projectsData?.projects ?? [];

  if (!isUserPending && (!isInnovator || !isSelectedCompanyParentOrganization)) {
    return <Navigate to={routes.home.path} />;
  }

  return (
    <PageviewTracker>
      <HelmetWrapper title="Projects" />
      <MainLayout>
        <Tile header={{ title: 'Projects' }}>
          {isProjectsPending ? (
            <div className="h-32 animate-pulse rounded-xl bg-muted" />
          ) : projects.length > 0 ? (
            <div className="overflow-hidden rounded-xl border">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead className="text-xs font-semibold text-gray-500">Name</TableHead>
                    <TableHead className="text-xs font-semibold text-gray-500">Location</TableHead>
                    <TableHead className="text-xs font-semibold text-gray-500">Country</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {projects.map((project) => (
                    <TableRow key={project.id}>
                      <TableCell className="text-sm font-medium text-gray-900">{project.name}</TableCell>
                      <TableCell className="text-sm text-gray-900">
                        {formatLocation({ city: project.city, state: project.state })}
                      </TableCell>
                      <TableCell className="text-sm text-gray-900">{formatCountry(project.country)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          ) : (
            <p className="text-sm text-gray-500">No projects found.</p>
          )}
        </Tile>
      </MainLayout>
    </PageviewTracker>
  );
};
